import { render, staticRenderFns } from "./FaqClient.vue?vue&type=template&id=07915924"
import script from "./FaqClient.vue?vue&type=script&lang=js"
export * from "./FaqClient.vue?vue&type=script&lang=js"
import style0 from "./FaqClient.vue?vue&type=style&index=0&id=07915924&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports